/* eslint import/no-cycle: 0 */
/* eslint no-restricted-syntax: 0 */
import React, { useState, memo, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import {
  Container,
  BurgerButton,
  Logo,
} from './styles'
import Icon from '../../icon'
import LogoSvg from '../../../assets/svg/logo-menu.svg'
import menuData from './utils/menu'
import NavItem from './NavItem'
import { useMe } from '../../../contexts/me'

export type ISubitem = {
  name: string;
  path: string;
  code: string;
}

export type IItem = {
  icon: string;
  name: string;
  code: string;
  path: string | null;
  subitems: ISubitem[],
}

const SidebarDashboard = () => {
  const history = useHistory()
  const { permissions } = useMe()

  const [isOpen, setIsOpen] = useState(false)
  const [currentSubmenuIndex, setCurrentSubmenuIndex] = useState<number | null>(null)
  const [filteredNavData, setFilteredNavData] = useState<IItem[]>([])

  const handleToggleSubmenu = (index: number) => {
    if (currentSubmenuIndex === index) {
      setCurrentSubmenuIndex(null)
    } else {
      setCurrentSubmenuIndex(index)
    }
  }

  const handleToggleMenu = () => {
    setIsOpen((state) => !state)
  }

  const handleRedirect = (path: string | null) => {
    if (path) {
      history.push(path)
    }
  }

  const handleItem = (item: IItem | ISubitem | any, index: number) => {
    const hasSubitems = item.subitems

    if (hasSubitems && item.subitems.length > 0) {
      handleToggleSubmenu(index)
      if (!isOpen) handleToggleMenu()
    } else {
      handleRedirect(item.path)
      if (isOpen) handleToggleMenu()
    }
  }

  const filterMenuItems = (perm: Set<unknown>) => {
    const formattedMenuData: IItem[] = []
    const formattedPermissions = Array.from(perm)

    menuData.forEach((item) => {
      const menuItem = { ...item }
      const subitems = menuItem.subitems.filter((subitem) => (
        formattedPermissions.includes(subitem.code)
      ))
      menuItem.subitems = subitems
      if ((menuItem.code && formattedPermissions.includes(menuItem.code)) || subitems.length > 0) {
        formattedMenuData.push(menuItem as IItem)
      }
    })

    return formattedMenuData as IItem[]
  }

  useEffect(() => {
    const filteredMenuData = filterMenuItems(permissions)
    setFilteredNavData(filteredMenuData)
  }, [permissions])

  return (
    <Container isOpen={isOpen}>
      <BurgerButton type="button" onClick={handleToggleMenu}>
        <Icon name="burger" />
        <Logo src={LogoSvg} alt="FingerMenu" isOpen={isOpen} />
      </BurgerButton>

      <nav>
        {
          filteredNavData.map((item, index) => (
            <NavItem
              key={item.path}
              item={item as IItem}
              sidebarIsOpen={isOpen}
              index={index}
              currentSubmenuIndex={currentSubmenuIndex}
              handleItem={handleItem}
            />
          ))
        }
      </nav>
    </Container>
  )
}

export default memo(SidebarDashboard)
